<template>
  <div class="page project">
    <h2>{{ project.name }}</h2>

    <ul>
      <li v-for="content in project.content">
        <vimeo-embed :url="content" v-if="isVimeo(content)" :key="content"></vimeo-embed>

        <img :src="imagePath(content)" v-if="isImage(content)" :key="content"></img>

        <p v-if="!isImage(content) && !isVimeo(content)" :key="content">
          {{ content }}
        </p>
      </li>
    </ul>

    <more-projects :project="project"></more-projects>
  </div>
</template>

<script>
import VimeoEmbed from './VimeoEmbed';
import MoreProjects from './MoreProjects';
import { imageUrl } from '../utils';

export default {
  name: 'project',
  components: {
    VimeoEmbed,
    MoreProjects
  },
  methods: {
    isImage (content) {
      return content.match(/\.(png|jpe?g|gif|svg)(\?.*)?$/);
    },
    isVimeo (content) {
      return content.match(/vimeo/);
    },
    imagePath (image) {
      return imageUrl(image);
    }
  },
  computed: {
    project () {
      if (this.$store.getters.selectedProject) {
        return this.$store.getters.selectedProject
      } else {
        this.$router.push('/');
        return {};
      }
    }
  }
}
</script>

<style>
.project {
  display: flex;
  flex-direction: column;
}

.project img {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// Project.vue?5e34a754